export const Logger = {
  error: (err: any, context?: any) => {
    console.log("ERROR: ", err, " CONTEXT: ", context);
  },
};
